import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

const Title = animated(styled.div`
  text-align: center;
  font-weight: 500;
  font-size: 1rem;
  line-height: 2rem;
  margin-bottom: 0.25rem;
  overflow: hidden;
  position: absolute;
  bottom: 100%;
  width: 100%;
`);

export default ({ children }) => (
  <Spring native from={{ height: '0rem', opacity: 0 }} to={{ height: '1.75rem', opacity: 1 }} config={{ delay: 400 }}>
    {animation => <Title style={animation}>{children}</Title>}
  </Spring>
);
